import {useParams} from 'react-router-dom'

import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import {
  MeterStat,
  Button,
  ProgressCircle,
  CentsMoney,
  Text,
} from 'common/components'
import {
  formatMoney,
  countPercentage,
  maybePluralize,
  formatDate,
} from 'common/helpers'
import {useGetProject, useGetDrawdowns} from '..'

export default function BorrowerProjectDrawdownsStats() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)
  const {data: drawdowns} = useGetDrawdowns(params.uuid)

  const receivedDrawdownsCount = drawdowns.filter(
    (drawdown) => drawdown.status === 'received'
  ).length
  const pendingDrawdowns = drawdowns.filter(
    (drawdown) =>
      drawdown.status !== 'received' && drawdown.status !== 'declined'
  )
  const pendingConfirmationDrawdownsCount = pendingDrawdowns.filter(
    (drawdown) => drawdown.status === 'approved'
  ).length
  const withdrawnPercent = countPercentage(
    project.withdrawn,
    project.facilityLimit1
  )
  const withdrawPendingPercent = countPercentage(
    project.withdrawPending,
    project.facilityLimit1
  )

  return (
    <div className={commonStyles.borrowerProjectPanel}>
      <div>
        <Text size="4xl" mb={4}>
          {maybePluralize(receivedDrawdownsCount, 'drawdown')} received
        </Text>
        <Text
          weight="medium"
          color={pendingConfirmationDrawdownsCount ? 'redError' : undefined}
          mb={16}
        >
          {pendingConfirmationDrawdownsCount
            ? `${maybePluralize(
                pendingConfirmationDrawdownsCount,
                'drawdown'
              )} pending your confirmation below`
            : pendingDrawdowns.length
            ? `${maybePluralize(
                pendingDrawdowns.length,
                'drawdown'
              )} pending - `
            : ''}
          {!pendingConfirmationDrawdownsCount &&
            `${withdrawnPercent}% of loan drawn`}
        </Text>
        <DrawdownRequestButton />
      </div>
      <div className={commonStyles.borrowerProjectStats}>
        <MeterStat
          large
          type="turquoize"
          title="Loan withdrawal"
          value={<CentsMoney value={project.withdrawn} />}
          label={`${formatMoney(project.availableWithdrawal, {
            cents: true,
          })} available`}
        />
        {Boolean(project.withdrawPending) && (
          <MeterStat
            large
            type="lightTurquoize"
            title="Pending drawdown"
            value={<CentsMoney value={project.withdrawPending} />}
            label={
              pendingDrawdowns[0]
                ? formatDate(pendingDrawdowns[0].createdAt, 'sixth')
                : undefined
            }
          />
        )}
        <ProgressCircle
          animation
          value={withdrawnPercent}
          extraValue={withdrawPendingPercent}
          radius={74}
          strokeWidth={10}
        >
          <Text weight="medium" size="3xl" color="turquoizeDeep">
            {withdrawnPercent}%
          </Text>
        </ProgressCircle>
        <MeterStat
          large
          right
          type="grey"
          title="Loan"
          value={<CentsMoney value={project.facilityLimit1} />}
          label="excluding interest & fees"
        />
      </div>
    </div>
  )
}

const DrawdownRequestButton = () => {
  const setDrawdownRequestOpen = useStore(
    (state) => state.setDrawdownRequestOpen
  )

  const handleOpen = () => setDrawdownRequestOpen(true)

  return <Button onClick={handleOpen}>request drawdown</Button>
}
